import {createStore, combineReducers, applyMiddleware} from "redux";
import thunkMiddleware from "redux-thunk";
//import { composeWithDevTools } from "redux-devtools-extension";

import {userReducer} from "./user/reducers";
import {eutrReducer} from "./eutr/reducers";
import {reachReducer} from "./reach/reducers";

const APP_STATE_STORAGE_KEY = "appState";

const rootReducer = combineReducers({
    user: userReducer,
    eutr: eutrReducer,
    reach: reachReducer
});

export type AppState = ReturnType<typeof rootReducer>;

export default function configureStore() {
    const middlewares = [thunkMiddleware];
    const persistedStore = loadState();
    const middleWareEnhancer = applyMiddleware(...middlewares);

    const store = createStore(
        rootReducer,
        persistedStore,
        middleWareEnhancer
        //,composeWithDevTools(middleWareEnhancer)
    );

    store.subscribe(() => {
        saveState(store.getState());
    });

    return store;
}

export const loadState = () => {
    try {
        const serializedState = sessionStorage.getItem(APP_STATE_STORAGE_KEY);
        if (!serializedState) {
            return undefined;
        } else {
            console.log('App state was loaded');
            return JSON.parse(serializedState);
        }
    } catch (err) {
        console.log('Failed to load the app state!');
        console.log(err);
        return undefined;
    }
};

export const saveState = (state: AppState) => {
    try {
        const serializedState = JSON.stringify(state);
        sessionStorage.setItem(APP_STATE_STORAGE_KEY, serializedState);
        console.log('App state was saved');
    } catch (err) {
        console.log('Failed to save the app state!');
        console.log(err);
    }
};

export const clearState = () => {
    try {
        sessionStorage.removeItem(APP_STATE_STORAGE_KEY);
        console.log('App state was cleared');
    } catch (err) {
        console.log('Failed to clear the app state!');
        console.log(err);
    }
};